export const CMS_APP_DEF_ID = 'e593b0bd-b783-45b8-97c2-873d42aacaf4'
export const VIEWER_CORE_SERVICES_APP_DEFINITION_ID = '1a711f05-2040-47df-a9f0-4f9cddb4c3c6'
export const WIX_HOTEL_PRODUCTION_APP_DEF_ID = '826670ba-3a6b-4157-ac72-7c4fca9ce220'
